/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Linux_Step2Inputs */

const en_gc_resources_download_linux_step2 = /** @type {(inputs: Gc_Resources_Download_Linux_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow the file to run as a program in Properties, or run chmod +x gridcraft-0.7.0-linux-x86_64.AppImage in that folder.`)
};

const zh_gc_resources_download_linux_step2 = /** @type {(inputs: Gc_Resources_Download_Linux_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在文件属性中允许作为程序执行，或在所在文件夹运行 chmod +x gridcraft-0.7.0-linux-x86_64.AppImage。`)
};

/**
* | output |
* | --- |
* | "Allow the file to run as a program in Properties, or run chmod +x gridcraft-0.7.0-linux-x86_64.AppImage in that folder." |
*
* @param {Gc_Resources_Download_Linux_Step2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_linux_step2 = /** @type {((inputs?: Gc_Resources_Download_Linux_Step2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Linux_Step2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_linux_step2(inputs)
	return zh_gc_resources_download_linux_step2(inputs)
});
export { gc_resources_download_linux_step2 as "gc.resources.download.linux.step2" }